module.exports = __webpack_public_path__ + "static/img/prize_5.49bb158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterOlympics/dialog/prize_5.png
// module id = qqrV
// module chunks = 33